import { Grid } from '@material-ui/core';
import InternalEmployeesFilterComponent from "./InternalEmployeesFilterComponent/InternalEmployeesFilterComponent";
import InternalEmployeesTableComponent from "./InternalEmployeesTableComponet/InternalEmployeesTableComponent";
import { styles, useStyles } from '../UserSearchScreenStyles';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as UserSearchActions from 'app/actions/UserSearchActions';
import { useState } from 'react';

const InternalEmployeesContainer = (props) => {
    const dispatch = useDispatch();

    useEffect(() => {
        //dispatch(UserSearchActions.getInternalEmployeesNames('')); /*No se carga al inicio por rendimiento*/
        dispatch(UserSearchActions.getInternalEmployeesSubdirection());
        //dispatch(UserSearchActions.getInternalEmployeesId('')); /*No se carga al inicio por rendimiento*/
        dispatch(UserSearchActions.getInternalEmployeesCompany());
        //dispatch(UserSearchActions.getInternalEmployeesCategory('')); /*No se carga al inicio por rendimiento*/
        dispatch(UserSearchActions.getInternalEmployeesContract());
        dispatch(UserSearchActions.getInternalEmployeesOt());
        //dispatch(UserSearchActions.getInternalEmployeesEmail('')); /*No se carga al inicio por rendimiento*/
        dispatch(UserSearchActions.fetchInternalEmployees({
            limit: 25,
            offset: 0
        }));
        dispatch(UserSearchActions.getInternalEmployeesEpep());        
        dispatch(UserSearchActions.getInternalEmployeesCeco());
    }, []);

    return (
        <div>
            <Grid container direction="row">
                <Grid item xs={12}>
                    <InternalEmployeesFilterComponent />
                </Grid>
                <Grid item xs={12}>
                    <InternalEmployeesTableComponent
                        showKardex={props.showKardex}
                        isVisibleKardex={props.isVisibleKardex}
                        setEmployeeId={props.setEmployeeId}
                        setIsExternal = {props.setIsExternal}
                    />
                </Grid>
            </Grid>
        </div>
    );
}

export default InternalEmployeesContainer;